module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/dark_theme-a92451100d1abe68a689ccb38f46e68c.png";